<!--
 * @Descripttion: 
 * @version: v1
 * @Author: liukx
 * @Date: 2022-05-01 23:09:12
 * @LastEditors: ???
 * @LastEditTime: 2022-05-14 20:04:46
-->
<template>
  <div class="wrapper">
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="visible"
      width="30%"
      @close="close"
    >
      <el-form
        :model="form"
        ref="form"
        :rules="validatorRules"
        label-width="80px"
        :inline="false"
        size="normal"
      >
        <el-form-item label="备注" prop="sysRemark">
          <el-input
            v-model="form.sysRemark"
            type="textarea"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="visible = false" size="mini">取消</el-button>
        <el-button type="primary" @click="handleOk" size="mini">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { httpAction } from '@/api/manage';

export default {
  components: {},
  props: {},
  data() {
    return {
      disableMixinCreated: true,
      options: [
        { label: '普通用户', value: 0 },
        { label: '管理员', value: 1 },
      ],
      title: '操作',
      visible: false,
      confirmLoading: false,
      form: {},
      validatorRules: {
        name: [
          { required: true, message: '请输入姓名!' },
          {
            min: 2,
            max: 30,
            message: '长度在 2 到 30 个字符',
            trigger: 'blur',
          },
        ],
        idCard: [{ required: true, message: '请输入身份证号!' }],
      },
      url: {
        edit: '/user/statistical/updateRemark',
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    add() {
      this.edit({});
    },
    edit(record) {
      this.form = Object.assign({}, record);
      this.visible = true;
    },
    close() {
      this.$refs.form.resetFields();
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          that.confirmLoading = true;
          let httpurl = this.url.edit;
          let method = 'post';
          let params = {
            orderId: this.form.orderId,
            remark: this.form.sysRemark,
          };

          httpAction(httpurl, params, method)
            .then((res) => {
              if (res.code == 200) {
                that.$message.success('操作成功');
                that.$emit('ok');
              } else {
                that.$message.warning(res.msg);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.wrapper {
}
</style>
